import { render } from "./TurnstileChallenge.vue?vue&type=template&id=68cc6d47&scoped=true"
import script from "./TurnstileChallenge.vue?vue&type=script&lang=ts"
export * from "./TurnstileChallenge.vue?vue&type=script&lang=ts"

import "./TurnstileChallenge.vue?vue&type=style&index=0&id=68cc6d47&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-68cc6d47"

export default script